export const SUPABASE_URL = "https://api.9990088.xyz";

export const SUPABASE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkZGltYWR6cGJjdm10b3Vqb2VjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAxMTE3NTksImV4cCI6MjA4NTY4Nzc1OX0.dMJdVjjr3D0oGRli1DE2ohvl-5abwLGHSPAaS8wREG0";

export const ADMIN_EMAIL = "liu@qq.com";

export const KEYS = {
  projects: "engineering_master_db",
  config: "engineering_config_v15",
  attendance: "attendance_master_db_v2",
  todo: "todo_master_db",
  calendar: "calendar_master_db",
  syncMeta: "office_sync_meta_v2",
  deviceId: "office_device_id_v1",
  migrationBackup: "office_v3_migration_backup_v1",
  preImportBackup: "office_pre_import_backup_v1",
  settlementRecords: "office_settlement_records_v1",
} as const;
